var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_25080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.66667V5H1.66667V1.66667H18.3333ZM18.3333 0H1.66667C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667V5C0 5.44203 0.175595 5.86595 0.488155 6.17851C0.800716 6.49107 1.22464 6.66667 1.66667 6.66667H18.3333C18.7754 6.66667 19.1993 6.49107 19.5118 6.17851C19.8244 5.86595 20 5.44203 20 5V1.66667C20 1.22464 19.8244 0.800716 19.5118 0.488155C19.1993 0.175595 18.7754 0 18.3333 0Z",
    fill: "#06362B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.0002V18.3335H1.66667V10.0002H5ZM5 8.3335H1.66667C1.22464 8.3335 0.800716 8.50909 0.488155 8.82165C0.175595 9.13421 0 9.55814 0 10.0002V18.3335C0 18.7755 0.175595 19.1994 0.488155 19.512C0.800716 19.8246 1.22464 20.0002 1.66667 20.0002H5C5.44203 20.0002 5.86595 19.8246 6.17851 19.512C6.49107 19.1994 6.66667 18.7755 6.66667 18.3335V10.0002C6.66667 9.55814 6.49107 9.13421 6.17851 8.82165C5.86595 8.50909 5.44203 8.3335 5 8.3335Z",
    fill: "#06362B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 10.0002V18.3335H10.0007V10.0002H18.334ZM18.334 8.3335H10.0007C9.55862 8.3335 9.1347 8.50909 8.82214 8.82165C8.50958 9.13421 8.33398 9.55814 8.33398 10.0002V18.3335C8.33398 18.7755 8.50958 19.1994 8.82214 19.512C9.1347 19.8246 9.55862 20.0002 10.0007 20.0002H18.334C18.776 20.0002 19.1999 19.8246 19.5125 19.512C19.8251 19.1994 20.0007 18.7755 20.0007 18.3335V10.0002C20.0007 9.55814 19.8251 9.13421 19.5125 8.82165C19.1999 8.50909 18.776 8.3335 18.334 8.3335Z",
    fill: "#06362B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_25080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedTemplate);
export default __webpack_public_path__ + "static/media/need_template.eae02da888517867416074083ba0203c.svg";
export { ForwardRef as ReactComponent };